import { render, staticRenderFns } from "./LegendChoroMap.vue?vue&type=template&id=3bcc2c21"
import script from "./LegendChoroMap.vue?vue&type=script&lang=js"
export * from "./LegendChoroMap.vue?vue&type=script&lang=js"
import style0 from "./LegendChoroMap.vue?vue&type=style&index=0&id=3bcc2c21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports